(() => {
  const header = document.querySelector('[data-ee-header]');
  if (!header) return;

  const trigger = header.querySelector('[data-ee-menu-toggle]');
  const menu = header.querySelector('[data-ee-mobile-menu]');
  const overlay = header.querySelector('[data-ee-menu-overlay]');
  const closeButton = header.querySelector('[data-ee-menu-close]');
  if (!trigger || !menu || !overlay || !closeButton) return;

  let lastFocus = null;

  const focusable = () => Array.from(
    menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
  );

  const openMenu = () => {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    menu.classList.add('is-open');
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    menu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-label', 'Close menu');
    document.body.classList.add('ee-menu-open');
    closeButton.focus();
  };

  const closeMenu = () => {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('ee-menu-open');
    window.setTimeout(() => {
      overlay.hidden = true;
    }, 230);
    if (lastFocus instanceof HTMLElement) lastFocus.focus();
  };

  trigger.addEventListener('click', () => {
    if (trigger.getAttribute('aria-expanded') === 'true') closeMenu();
    else openMenu();
  });
  closeButton.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
  menu.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', closeMenu));

  document.addEventListener('keydown', (event) => {
    if (trigger.getAttribute('aria-expanded') !== 'true') return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }
    if (event.key !== 'Tab') return;

    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const desktopQuery = window.matchMedia('(min-width: 1041px)');
  desktopQuery.addEventListener('change', (event) => {
    if (event.matches && trigger.getAttribute('aria-expanded') === 'true') closeMenu();
  });
})();
